(() => {
 const initialize = (root) => {
  root.querySelectorAll('[data-waitlist]').forEach((section) => {
   if (section.dataset.initialized) return;
   section.dataset.initialized = 'true';
   if (section.dataset.rotateColours === 'true') {
    const palette = [
     ['#FDE412', '#0A0A0A'], ['#6EA8CC', '#0A0A0A'],
     ['#EBB9C5', '#0A0A0A'], ['#EF7023', '#0A0A0A'],
     ['#BBD5D5', '#0A0A0A'], ['#77653F', '#FFFFFF'], ['#245143', '#FFFFFF']
    ];
    let index = 0;
    const applyColour = () => {
     section.style.setProperty('--waitlist-background', palette[index][0]);
     section.style.setProperty('--ink', palette[index][1]);
     section.dataset.paletteIndex = String(index);
    };
    applyColour();
    const seconds = Math.max(3, Number(section.dataset.colourInterval) || 5);
    const colourTimer = setInterval(() => {
     if (!section.isConnected) { clearInterval(colourTimer); return; }
     if (document.hidden) return;
     index = (index + 1) % palette.length;
     applyColour();
    }, seconds * 1000);
   }
   const deadline = Date.parse(section.dataset.deadline);
   if (!Number.isFinite(deadline)) return;
   let timer;
   const update = () => {
    const remaining = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
    const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
    Object.entries(values).forEach(([unit, value]) => { section.querySelector(`[data-time-unit="${unit}"]`).textContent = String(value).padStart(2, '0'); });
    section.querySelector('[data-waitlist-ended]').hidden = remaining > 0;
    if (remaining === 0 && timer) clearInterval(timer);
   };
   update();
   if (deadline > Date.now()) timer = setInterval(() => { if (!section.isConnected) clearInterval(timer); else update(); }, 1000);
  });
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document)); else initialize(document);
 document.addEventListener('shopify:section:load', (event) => initialize(event.target.parentElement));
})();
